// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FhAZ","title":"styles_title__1piWM"};